import { render, staticRenderFns } from "./TopazSignature.vue?vue&type=template&id=8e19ae14&scoped=true"
import script from "./TopazSignature.vue?vue&type=script&lang=js"
export * from "./TopazSignature.vue?vue&type=script&lang=js"
import style0 from "./TopazSignature.vue?vue&type=style&index=0&id=8e19ae14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e19ae14",
  null
  
)

export default component.exports